/**
 * BluJay Partner Filter functionality
 *
 * Frontend interaction handling
 *
 * @since 1.0.0
 */
'use strict';

var BluJayPartnerFilter = {};

BluJayPartnerFilter.init = function() {
	var $ = jQuery;
	var $archiveFilters = $( '.archive-filters' );
	var $archiveFiltersLoader = $( '.loader', $archiveFilters );
	var $archiveFilterFields = $( 'select', $archiveFilters );

	// handle filter field change
	$archiveFilterFields.on( 'change', submitArchiveFilters );

	/**
	 * Submit the archive filter fields on change
	 *
	 * @since 1.0.0
	 */
	function submitArchiveFilters() {
		$archiveFiltersLoader.css( 'display', 'flex' ).hide().fadeIn( 200 );
		$archiveFilters.submit();
	}
};

jQuery( document ).ready( BluJayPartnerFilter.init );
